<template>
  <div class="steps" v-if="configure">
    <el-row>
      <el-col :span="5">你喜欢的词库风格</el-col>
      <el-col :span="19">
        <el-radio-group
          v-model="configure.global.thesaurus"
          size="small"
          @change="thesaurusChange"
        >
          <el-radio-button label="man">朴素风格</el-radio-button>
          <el-radio-button label="girl">花式风格</el-radio-button>
        </el-radio-group>
        <q>
          <p><el-tag type="info" size="mini">朴素</el-tag>欢迎 小虎弟</p>
          <p>
            <el-tag size="mini">花式</el-tag>小虎弟来了，欢迎欢迎、日久生情 ♥
          </p>
        </q>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="5">主播昵称</el-col>
      <el-col :span="19">
        <el-input
          class="anchor-nickname"
          size="medium"
          v-model.trim="configure.global.anchorNick"
          placeholder="请输入主播昵称"
        ></el-input>
        的直播间
      </el-col>
    </el-row>
    <div class="bottom-actions">
      <button class="button plain" @click="backToAccout">上一步</button>
      <button class="button" @click="save">完成</button>
    </div>
    <!-- <div class="button-row footer">
      <el-button size="mini" icon="el-icon-back" @click="backToAccout">上一步</el-button>
      <el-button size="mini" icon="el-icon-right" type="primary" @click="save">完成</el-button>
    </div> -->
  </div>
</template>

<script>
import {
  userInfo,
  getConfig,
  getFeatureList,
  updateConfig,
  getFeatureWords,
} from "@/api/index";
import { deepObjectMerge } from "@/utils/object";
import { Message } from "element-ui";
export default {
  data() {
    return {
      configure: null,
      cloud: {
        user: null,
        enable: false,
      },
      input: "",
    };
  },
  created() {
    userInfo(null, { notify: false }).then((res) => {
      if (res.code == -2050) {
        localStorage.removeItem("sid");
        this.$router.replace("/login");
      } else {
        this.user = res.data;
        this.ticket = res.data.ticket;
        this.getConfig();
      }
    });
  },
  methods: {
    getConfig() {
      getConfig(
        {
          ticket: this.ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          const configure = res.data.configure;
          let d = JSON.parse(configure);
          if (this.configure == null) {
            this.configure = d;
          } else {
            Object.assign(this.configure, d);
          }
          this.configure.features = res.data.features;
          this.getFeaturList();
        }
      });
    },
    getFeaturList() {
      getFeatureList(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          const featureList = res.data.featureList;
          featureList.forEach((val, index) => {
            if (this.configure[val.jsonField]) {
              this.configure[val.jsonField] = deepObjectMerge(
                JSON.parse(val.defaultData),
                this.configure[val.jsonField]
              );
            } else {
              this.$set(
                this.configure,
                val.jsonField,
                deepObjectMerge({}, JSON.parse(val.defaultData))
              );
            }
          });
        }
      });
    },
    thesaurusChange(val) {
      if (!this.thesaurusWords) {
        getFeatureWords({ notify: false }).then((res) => {
          if (res.code === 0) {
            this.thesaurusWords = res.data.words;
            this.changeThesaurusConfirm(val);
          }
        });
      } else {
        this.changeThesaurusConfirm(val);
      }
    },
    changeThesaurusConfirm(val) {
      if (val === "girl") {
        for (let item in this.thesaurusWords.female) {
          for (let subitem in this.thesaurusWords.female[item]) {
            this.configure[item][subitem].tpl = JSON.parse(
              JSON.stringify(this.thesaurusWords.female[item][subitem].tpl)
            );
          }
        }
      }
      if (val === "man") {
        for (let item in this.thesaurusWords.male) {
          for (let subitem in this.thesaurusWords.male[item]) {
            this.configure[item][subitem].tpl = JSON.parse(
              JSON.stringify(this.thesaurusWords.male[item][subitem].tpl)
            );
          }
        }
        this.configure.giftTks.giftTksPreWords.preEnable = false;
      }
      this.configure.global.thesaurus = val;
      // if (!this.isShowGuide) {
      //   this.$confirm(
      //     `即将载入${
      //       val == "girl" ? "花式词库" : "朴素词库"
      //     }，如果有自己配置过的句子会被覆盖`,
      //     "提示",
      //     {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //     }
      //   )
      //     .then((action) => {
      //       if (action == "confirm") {
      //       }
      //     })
      //     .catch((error) => {
      //       if (error == "cancel") {
      //         if (val === "girl") {
      //           this.configure.global.thesaurus = "man";
      //         } else {
      //           this.configure.global.thesaurus = "girl";
      //         }
      //         setTimeout(() => {
      //           this.isChange = false;
      //         }, 0);
      //       }
      //     });
      // }
    },
    save() {
      updateConfig({
        configure: JSON.stringify(this.configure),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          // this.$message.success("保存配置成功");
          this.linkToRobotManager();
        }
      });
    }, // 保存配置
    backToAccout() {
      this.$router.replace("/guideRate");
    },
    linkToRobotManager() {
      localStorage.removeItem("guidePage");
      this.$router.replace("/robotManager");
    },
  },
};
</script>
